class AlgoliaBadgeSale extends HTMLElement {
  constructor() {
    super();

    this.connectedCallback = this.connectedCallback.bind(this);
    this.getSaleLabel = this.getSaleLabel.bind(this);
    this.getStyle = this.getStyle.bind(this);
    this.render = this.render.bind(this);
  }

  /**
   * Initializes settings based on custom attributes when the element is connected to the DOM.
   * @returns {void}
   */
  connectedCallback() {
    this.settings = {
      saleBadgeAllCaps: this.getAttribute('sale-badge-all-caps').toLowerCase() === 'true',
      saleBadgeBorderColor: this.getAttribute('sale-badge-border-color'),
      saleBadgeBorderRadius: this.getAttribute('sale-badge-border-radius'),
      saleBadgeBorderWidth: this.getAttribute('sale-badge-border-width'),
      saleBadgeFillColor: this.getAttribute('sale-badge-fill-color'),
      saleBadgeFontSize: this.getAttribute('sale-badge-font-size'),
      saleBadgePaddingX: this.getAttribute('sale-badge-padding-x'),
      saleBadgePaddingY: this.getAttribute('sale-badge-padding-y'),
      saleBadgeTextColor: this.getAttribute('sale-badge-text-color'),
      yAdjustedMap: this.getAttribute('y-adjusted-map')
    }
  }

  /**
   * Retrieves the sale label for an item based on trove facets and adjusted maps.
   * @param {object} item - The item object containing meta information.
   * @returns {string} The sale label for the item, or an empty string if not found.
   */
  getSaleLabel(item) {
    try {
      const troveFacets = item?.meta['trove-facets'];
      const markdownReason = troveFacets?.markdownReason || [];

      const adjustedMaps = JSON.parse(this.settings.yAdjustedMap);
      const matchedMap = adjustedMaps.find(adjustedMap => markdownReason.includes(adjustedMap.yadjusted_code));

      return matchedMap ? matchedMap.display_name : '';
    } catch {
      return '';
    }
  }

  /**
   * Returns the CSS styles.
   * @returns {string} The CSS style block as a string.
   */
  getStyle() {
    const style = document.createElement('style');
    const css = `
      .badge--sale {
        background-color: ${this.settings.saleBadgeFillColor};
        border-color: ${this.settings.saleBadgeBorderColor};
        border-radius:${this.settings.saleBadgeBorderRadius}px;
        border-style: solid;
        border-width: ${this.settings.saleBadgeBorderWidth}px;
        color: ${this.settings.saleBadgeTextColor};
        display: inline-block;
        padding-block: ${this.settings.saleBadgePaddingY}px;
        padding-inline: ${this.settings.saleBadgePaddingX}px;
      }
    `;
    style.appendChild(document.createTextNode(css));
    return style;
  }

  /**
   * Renders the sale badge content.
   * @returns {string} The rendered sale badge.
   */
  render(item) {
    const saleLabel = this.getSaleLabel(item);
    if (!saleLabel) return [];

    const style = this.getStyle();
    const div = document.createElement('div');
    div.classList.add('badge--sale', this.settings.saleBadgeFontSize);
    if (this.settings.saleBadgeAllCaps) div.classList.add('p-all-caps');
    const span = document.createElement('span');
    span.textContent = saleLabel;
    div.appendChild(span);

    return [style, div];
  }
}

customElements.define("algolia-badge-sale", AlgoliaBadgeSale);
